/*
* 项目报价管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Button,
    InputNumber,
    Space,
    Tag,
    theme,
    Statistic,
    Select,
} from 'antd';
import { PlusOutlined, ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    rootReactDom,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import OfferEntity from './OfferEntity';
import OfferAuditEntity from './OfferAuditEntity';
import OfferPrinter from './OfferPrinter';

const MODULENAME = CNF.navItems[0].submenu[2].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[2].ptn;

const Lists = (props) => {
    const update = (record) => { props.setOpen(true, record); }

    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            green6,
            green1,
            red6,
            red1,
            cyan1,
            cyan6,
            blue1,
            blue6,

        },
    } = theme.useToken();

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'project/offers/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.AUDIT:
                audit(record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, props.isRefresh, uri);
                break;
            default:
                break;
        }
    }

    /**
     * 预览项目报价
     * @param {*} record 
     */
    const preview = (record) => {
        rootReactDom && rootReactDom.render(
            <OfferPrinter
                colorPrimaryBg={colorPrimaryBg}
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                record={record}
            />);
    }

    /**
     * 项目报价审计
     * @param {*} record 
     */
    const audit = (record) => {
        rootReactDom && rootReactDom.render(<OfferAuditEntity
            preGroup={props.preGroup}
            btnLists={props.btnLists}
            open={true}
            record={record}
            isRefresh={props.isRefresh}
        />);

    }

    /**
     * 调整比例
     * @param {*} record 
     */
    const adjustmentRatio = (record) => {
        if (parseFloat(record.amount) >= parseFloat(record.init_amount)) {
            let initTotal = parseFloat(record.init_amount) + parseFloat(record.init_tax_amount);
            let total = parseFloat(record.amount) + parseFloat(record.tax_amount);
            return ((total - initTotal) / initTotal * 100).toFixed(CNF.DPL);
        } else {
            let initTotal = parseFloat(record.init_amount) + parseFloat(record.init_tax_amount);
            let total = parseFloat(record.amount) + parseFloat(record.tax_amount);
            return '-' + ((initTotal - total) / initTotal * 100).toFixed(CNF.DPL);
        }
    }

    /**
     * 核减比例
     * @param {*} record 
     */
    const deductionRatio = (record) => {
        if (parseFloat(record.audited_amount) > 0) {
            let total = parseFloat(record.amount) + parseFloat(record.tax_amount);
            let auditedTotal = parseFloat(record.audited_amount) + parseFloat(record.audited_tax_amount);
            return ((total - auditedTotal) / total * 100).toFixed(CNF.DPL);
        } else {
            return '-'
        }
    }

    const columns = [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        {
            title: '报价名称', key: 'name',
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: 0, border: 0, height: 22 }}
                onClick={() => { preview(record); }}>{record.name}</Button>
        },
        {
            title: '版本', key: 'version',
            render: function (record) {
                return 'v' + record.version;
            }
        },
        {
            title: '初始报价总计(元)', key: 'init_total',
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={parseFloat(record.init_amount) + parseFloat(record.init_tax_amount)} /></Tag>
        },
        {
            title: '报价总计(元)', key: 'total',
            render: (record) => <Tag color={green1} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: green6 }} value={parseFloat(record.amount) + parseFloat(record.tax_amount)} /></Tag>
        },
        {
            title: '审核总计(元)', key: 'audited_amount',
            render: (record) => <Tag color={red1} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: red6 }} value={parseFloat(record.audited_amount) + parseFloat(record.audited_tax_amount)} /></Tag>
        },
        {
            title: '调整比例(%)', key: 'adjustment_ratio',
            render: (record) => <Tag color={cyan1} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: cyan6 }} value={adjustmentRatio(record)} /></Tag>
        },
        {
            title: '核减比例(%)', key: 'deduction_ratio',
            render: (record) => <Tag color={blue1} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: blue6 }} value={deductionRatio(record)} /></Tag>
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_audit') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetDropdownActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                // scroll={{ x: winWidth}} 
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            name: '',
            version: 0,
            status: '',
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeName = (e) => { this.setState({ name: e.target.value }); this.search(); }
    changeVersion = (value) => { this.setState({ version: value === null ? 0 : value }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value === undefined ? '' : value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 导出 Excel
     * @param {*} record 
     * @param {*} data 
     */
    exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目报价管理.' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目报价清单',  //  excel文件中sheet页名称
                sheetHeader: [
                    '报价名称',
                    '版本号',
                    '金额(元)',
                    '税费(元)',
                    '审核金额(元)',
                    '审核税费(元)',
                    '有效期限(月)',
                    '客户名称',
                    '地址',
                    '联系人',
                    '电话',
                    '邮箱',
                    '报价单位',
                    '地址',
                    '联系人',
                    '电话',
                    '邮箱',
                    '报价日期',
                    '状态',
                    '备注'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 执行导出
     */
    export = () => {
        const _this = this
        const params = {
            'name': this.state.name,
            'version': this.state.version,
            'status': this.state.status,
            'page_size': 65535,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}project/offers${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['create_username'];
                            delete item['create_displayname'];
                            delete item['create_time'];
                            delete item['update_time'];
                            delete item['init_amount'];
                            delete item['init_tax_amount'];
                            d.push(item);
                        }
                        _this.exportAsExcel(d);
                    } else {
                        _this.exportAsExcel([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'name': this.state.name,
            'version': this.state.version,
            'status': this.state.status,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}project/offers${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            placeholder='报价名称'
                            onChange={this.changeName}
                            value={this.state.name}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 3 : 4} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <InputNumber

                            placeholder='版本号'
                            prefix='版本号: v'
                            style={{ width: '100%' }}
                            min={0}
                            step={1}
                            onChange={this.changeVersion}
                            value={this.state.version > 0 ? this.state.version : ''}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                            options={CNF.offerStatus.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.label
                            }))}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <OfferEntity
                        preGroup={this.props.preGroup}
                        btnLists={this.props.btnLists}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        actionSource='OFFER'
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            preGroup={this.props.preGroup}
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT